import { FunctionComponent, ReactNode, useMemo } from 'react';
import CountUp from 'react-countup';

export type FormatoKpi = 'entero' | 'decimal1' | 'fraccion';
export type VarianteKpi = 'hero' | 'compacto';

const formatearEntero = (v: number): string =>
  Math.round(v).toLocaleString('es-CL');

const formatearDecimal1 = (v: number): string =>
  v.toLocaleString('es-CL', { maximumFractionDigits: 1, minimumFractionDigits: 1 });

const KpiCard: FunctionComponent<{
  valor: number;
  label: string;
  comparacion?: string;
  formato?: FormatoKpi;
  denominador?: number;
  variante?: VarianteKpi;
  icono?: ReactNode;
  duracionAnimacion?: number;
}> = ({
  valor,
  label,
  comparacion,
  formato = 'entero',
  denominador,
  variante = 'hero',
  icono,
  duracionAnimacion = 1.2
}) => {
  const decimals = formato === 'decimal1' ? 1 : 0;
  const formattingFn = useMemo(
    () => (formato === 'decimal1' ? formatearDecimal1 : formatearEntero),
    [formato]
  );

  return (
    <div className={`kpi-card kpi-card--${variante}`}>
      {icono && <div className='kpi-card-icono'>{icono}</div>}

      <div className='kpi-card-valor-row'>
        <span className='kpi-card-valor'>
          <CountUp
            end={valor}
            duration={duracionAnimacion}
            decimals={decimals}
            formattingFn={formattingFn}
            useEasing
            enableScrollSpy
            scrollSpyOnce
            preserveValue
          />
        </span>
        {formato === 'fraccion' && typeof denominador === 'number' && (
          <span className='kpi-card-denominador'>{` / ${denominador}`}</span>
        )}
      </div>

      <div className='kpi-card-label'>{label}</div>

      {variante === 'hero' && comparacion && (
        <div className='kpi-card-comparacion'>{comparacion}</div>
      )}
    </div>
  );
};

export default KpiCard;
